import { AnyAction } from 'redux';
import { EffectsCommandMap, Subscription, SubscriptionAPI } from 'dva';
import { DvaReducer } from './shared';
import { AVATAR_URL_PREFIX } from '@/constants';
import { ConnectState } from '@/models/connect';
import { FUtil, FServiceAPI } from '@freelog/tools-lib';
import { listStateAndListMore } from '@/components/FListFooter';
import dayjs from 'dayjs';
import {
  buildResourceListApiParams,
  defaultResourceTypeCodesFilterAll,
  handleBatchUpdateFeedback,
  fetchFailedResourceInfo,
  applyBatchUpdateToList,
} from '@/models/shared/resourceListHelpers';

export interface CollectionListPageModelState {
  resourceTypeCodes: {
    value: string;
    label: string;
    values: string[];
    labels: string[];
  };
  resourceStatus: 0 | 1 | 2 | 4 | '#';
  inputText: string;
  inputText_search: string;

  isBatchManagement: boolean;
  checkedResourceIDs: string[];
  // updateResourceResultType: '' | 'online' | 'offline' | 'addPolicy',
  // updateResourceResult: {
  //   [k: string]: {
  //     data: string;
  //     status: 1 | 2;
  //   };
  // } | null;

  resource_List: {
    id: string;
    cover: string;
    name: string;
    title: string;
    version: string;
    policy: string[];
    type: string[];
    status: 0 | 1 | 2 | 4;
    authProblem: boolean;
    updateDate: string;
    username: string;
    useAvatar: string;
    isChoice: boolean;

    isFinish: boolean;
    itemsCount: number;
    itemsNames: string[];
  }[];
  resource_ListState: 'loading' | 'noData' | 'noSearchResult' | 'loaded';
  resource_ListMore: 'loading' | 'andMore' | 'noMore';
}

export interface ChangeAction extends AnyAction {
  type: 'change' | 'collectionListPage/change';
  payload: Partial<CollectionListPageModelState>;
}

export interface OnMountAction extends AnyAction {
  type: 'collectionListPage/onMount';
}

export interface OnUnmountAction extends AnyAction {
  type: 'collectionListPage/onUnmount';
}

export interface FetchDataSourceAction extends AnyAction {
  type: 'fetchDataSource';
  payload: {
    restart: boolean;
  };
}

export interface OnChangeResourceTypeAction extends AnyAction {
  type: 'collectionListPage/onChangeResourceType';
  payload: {
    value: CollectionListPageModelState['resourceTypeCodes'];
  };
}

export interface OnChangeStatusAction extends AnyAction {
  type: 'collectionListPage/onChangeStatus';
  payload: {
    value: 0 | 1 | 2 | 4 | '#';
  };
}

export interface OnChangeKeywordsAction extends AnyAction {
  type: 'collectionListPage/onChangeKeywords';
  payload: {
    value: string;
  };
}

export interface OnAwaited_KeywordsChange_Action extends AnyAction {
  type: 'collectionListPage/onAwaited_KeywordsChange';
}

export interface OnClickLoadingMordAction extends AnyAction {
  type: 'collectionListPage/onClickLoadingMord';
}

export interface OnBatchUpdateAction extends AnyAction {
  type: 'collectionListPage/onBatchUpdate';
  payload: {
    status?: 1 | 4;
    addPolicies?: {
      policyName: string;
      policyText: string;
      status: 0 | 1;
    }[];
  };
}

export interface CollectionListPageModelType {
  namespace: 'collectionListPage';
  state: CollectionListPageModelState;
  effects: {
    onMount: (action: OnMountAction, effects: EffectsCommandMap) => void;
    onUnmount: (action: OnUnmountAction, effects: EffectsCommandMap) => void;
    fetchDataSource: (
      action: FetchDataSourceAction,
      effects: EffectsCommandMap,
    ) => void;
    onChangeResourceType: (
      action: OnChangeResourceTypeAction,
      effects: EffectsCommandMap,
    ) => void;
    onChangeStatus: (
      action: OnChangeStatusAction,
      effects: EffectsCommandMap,
    ) => void;
    onChangeKeywords: (
      action: OnChangeKeywordsAction,
      effects: EffectsCommandMap,
    ) => void;
    onAwaited_KeywordsChange: (
      action: OnAwaited_KeywordsChange_Action,
      effects: EffectsCommandMap,
    ) => void;
    onClickLoadingMord: (
      action: OnClickLoadingMordAction,
      effects: EffectsCommandMap,
    ) => void;
    onBatchUpdate: (
      action: OnBatchUpdateAction,
      effects: EffectsCommandMap,
    ) => void;
  };
  reducers: {
    change: DvaReducer<CollectionListPageModelState, ChangeAction>;
  };
  subscriptions: {
    setup: Subscription;
  };
}

const initStates: CollectionListPageModelState = {
  resourceTypeCodes: defaultResourceTypeCodesFilterAll(),
  resourceStatus: '#',
  inputText: '',
  inputText_search: '',
  isBatchManagement: false,
  checkedResourceIDs: [],
  // updateResourceResultType: '',
  // updateResourceResult: null,
  resource_List: [],
  resource_ListState: 'loading',
  resource_ListMore: 'loading',
};

const Model: CollectionListPageModelType = {
  namespace: 'collectionListPage',

  state: initStates,

  effects: {
    *onMount({}: OnMountAction, { put }: EffectsCommandMap) {
      // yield put<FetchDataSourceAction>({
      //   type: 'fetchDataSource',
      //   payload: {
      //     restart: true,
      //   },
      // });
    },
    *onUnmount({}: OnUnmountAction, { put }: EffectsCommandMap) {
      yield put<ChangeAction>({
        type: 'change',
        payload: initStates,
      });
    },
    *fetchDataSource(
      { payload }: FetchDataSourceAction,
      { call, put, select }: EffectsCommandMap,
    ) {
      const { collectionListPage }: ConnectState = yield select(
        ({ collectionListPage }: ConnectState) => ({
          collectionListPage,
        }),
      );
      let resource_List: CollectionListPageModelState['resource_List'] = [];
      if (!payload.restart) {
        resource_List = collectionListPage.resource_List;
        yield put<ChangeAction>({
          type: 'change',
          payload: {
            // resource_ListState: 'loading',
            resource_ListMore: 'loading',
          },
        });
      }
      const params: Parameters<typeof FServiceAPI.Resource.list>[0] =
        buildResourceListApiParams({
          listLength: resource_List.length,
          keywords: collectionListPage.inputText,
          resourceTypeCodes: collectionListPage.resourceTypeCodes,
          resourceStatus: collectionListPage.resourceStatus,
          subjectType: 4,
        });

      const {
        ret,
        errCode,
        data: data_resourceList,
      }: {
        ret: number;
        errCode: number;
        data: {
          limit: number;
          skip: number;
          totalItem: number;
          dataList: {
            resourceId: string;
            resourceName: string;
            resourceTitle: string;
            resourceType: string[];
            latestVersion: string;
            coverImages: string[];
            status: 0 | 1;
            policies: {
              policyId: string;
              policyName: string;
              status: 0 | 1;
            }[];
            userId: number;
            updateDate: string;
            username: string;
            operationType: 0 | 1 | 2 | 3 | 4 | 5;
            serializeStatus?: 0 | 1;
            resourceVersions: { versionId: string }[];
          }[];
        };
      } = yield call(FServiceAPI.Resource.list, params);
      // console.log(
      //   data_resourceList,
      //   'data_resourceList ((((((((((((((((((((((((((((',
      // );

      let auths: any[] = [];
      let data_resourceItems: {
        resourceId: string;
        itemList: {
          createDate: string;
          itemId: string;
          itemTitle: string;
          sortId: number;
          number: string;
          mountResourceInfo: {
            resourceId: string;
            resourceName: string;
            resourceTitle: string;
          };
        }[];
        totalItem: number;
      }[] = [];
      let data_versionList: {
        resourceId: string;
        versionId: string;
        catalogueProperty: {
          collection_sort_list?:
            | 'collection_sort_ascending'
            | 'collection_sort_descending';
          collection_item_title?:
            | 'collection_item_title_rtitle'
            | 'collection_item_title_sn'
            | 'collection_item_title_empty'
            | 'collection_item_title_custom';
        };
      }[] = [];
      const resourceIds: string = data_resourceList.dataList
        .filter((r) => {
          return r.latestVersion !== '';
        })
        .map((r) => {
          return r.resourceId;
        })
        .join(',');
      if (resourceIds !== '') {
        const parmas1: Parameters<typeof FServiceAPI.Resource.batchAuth>[0] = {
          resourceIds: resourceIds,
        };
        const { data: data1 } = yield call(
          FServiceAPI.Resource.batchAuth,
          parmas1,
        );
        auths = data1;

        const parmas3: Parameters<
          typeof FServiceAPI.Resource.getVersionList
        >[0] = {
          versionIds: data_resourceList.dataList
            .filter((r) => {
              return r.latestVersion !== '';
            })
            .map((r) => {
              return r.resourceVersions[0].versionId;
            })
            .join(','),
        };
        const { data: data3 } = yield call(
          FServiceAPI.Resource.getVersionList,
          parmas3,
        );
        data_versionList = data3;

        const params2: Parameters<
          typeof FServiceAPI.Resource.batchResourceItems
        >[0] = {
          resourceIds: resourceIds,
          limit: 10,
          sortField: 'createDate',
          sortType: -1,
          isLoadItemResourceDetailInfo: 1,
          // @ts-ignore
          isLoadLatestVersionInfo: 1,
        };
        const {
          data: data2,
        }: {
          data: {
            resourceId: string;
            itemList: {
              createDate: string;
              itemId: string;
              itemTitle: string;
              sortId: number;
              number: string;
              mountResourceInfo: {
                resourceId: string;
                resourceName: string;
                resourceTitle: string;
              };
            }[];
            totalItem: number;
          }[];
        } = yield call(FServiceAPI.Resource.batchResourceItems, params2);
        data_resourceItems = data2;
      }

      const finalList = [
        ...resource_List,
        ...data_resourceList.dataList.map<
          CollectionListPageModelState['resource_List'][number]
        >((i, j) => {
          const res = auths.find((dd: any) => {
            return dd.resourceId === i.resourceId;
          });

          const versonInfo = data_versionList.find((v) => {
            return v.resourceId === i.resourceId;
          });

          const resource = data_resourceItems.find((dri) => {
            return dri.resourceId === i.resourceId;
          });

          // console.log(
          //   resource,
          //   'resource sdoifj;sldkjf;lkajsdklfjl;jl **********************',
          // );
          return {
            id: i.resourceId,
            cover: i.coverImages.length > 0 ? i.coverImages[0] : '',
            name: i.resourceName,
            title: i.resourceTitle,
            version: i.latestVersion,
            policy: i.policies
              .filter((l) => {
                return l.status === 1;
              })
              .map((l: any) => l.policyName),
            type: i.resourceType,
            status: i.status,
            authProblem: !!res && !res.isAuth,
            updateDate: dayjs(i.updateDate).format(FUtil.Predefined.momentDateFormat),
            username: i.username,
            useAvatar: `${AVATAR_URL_PREFIX}${i.userId}`,
            isChoice: i.operationType === 5,

            isFinish: i.serializeStatus === 1,
            // itemsCount: responds[j].count,
            itemsCount: resource?.totalItem || 0,
            itemsNames:
              resource?.itemList.map((ri) => {
                return (
                  (versonInfo?.catalogueProperty?.collection_item_title ===
                  'collection_item_title_custom'
                    ? ri.itemTitle
                    : versonInfo?.catalogueProperty?.collection_item_title ===
                      'collection_item_title_sn'
                    ? ri.number
                    : ri.mountResourceInfo.resourceTitle) ||
                  ri.mountResourceInfo.resourceTitle
                );
              }) || [],
          };
        }),
      ];

      const { state, more } = listStateAndListMore({
        list_Length: finalList.length,
        total_Length: data_resourceList.totalItem,
        has_FilterCriteria:
          collectionListPage.inputText !== '' ||
          collectionListPage.resourceTypeCodes.value !== '#all' ||
          collectionListPage.resourceStatus !== '#',
      });

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          resource_List: finalList,
          resource_ListState: state,
          resource_ListMore: more,
          inputText_search: collectionListPage.inputText,
        },
      });
    },
    *onChangeResourceType(
      { payload }: OnChangeResourceTypeAction,
      { put }: EffectsCommandMap,
    ) {
      yield put<ChangeAction>({
        type: 'change',
        payload: {
          resourceTypeCodes: payload.value,
        },
      });

      yield put<FetchDataSourceAction>({
        type: 'fetchDataSource',
        payload: {
          restart: true,
        },
      });
    },
    *onChangeStatus(
      { payload }: OnChangeStatusAction,
      { put }: EffectsCommandMap,
    ) {
      yield put<ChangeAction>({
        type: 'change',
        payload: {
          resourceStatus: payload.value,
        },
      });

      yield put<FetchDataSourceAction>({
        type: 'fetchDataSource',
        payload: {
          restart: true,
        },
      });
    },
    *onChangeKeywords(
      { payload }: OnChangeKeywordsAction,
      { put }: EffectsCommandMap,
    ) {
      yield put<ChangeAction>({
        type: 'change',
        payload: {
          inputText: payload.value,
        },
      });
    },
    *onAwaited_KeywordsChange(
      {}: OnAwaited_KeywordsChange_Action,
      { put }: EffectsCommandMap,
    ) {
      yield put<FetchDataSourceAction>({
        type: 'fetchDataSource',
        payload: {
          restart: true,
        },
      });
    },
    *onClickLoadingMord(
      {}: OnClickLoadingMordAction,
      { put }: EffectsCommandMap,
    ) {
      yield put<FetchDataSourceAction>({
        type: 'fetchDataSource',
        payload: {
          restart: false,
        },
      });
    },
    *onBatchUpdate(
      { payload }: OnBatchUpdateAction,
      { select, call, put }: EffectsCommandMap,
    ) {
      const { collectionListPage }: ConnectState = yield select(
        ({ collectionListPage }: ConnectState) => ({
          collectionListPage,
        }),
      );

      const params: Parameters<typeof FServiceAPI.Resource.batchUpdate>[0] = {
        resourceIds: collectionListPage.checkedResourceIDs,
        ...payload,
      };
      const {
        data,
      }: {
        data: {
          [resourceID: string]: {
            data: any;
            status: 1 | 2;
          };
        };
      } = yield call(FServiceAPI.Resource.batchUpdate, params);

      yield call(handleBatchUpdateFeedback, data, payload);

      const failResources: any[] = yield call(fetchFailedResourceInfo, data);

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          resource_List: applyBatchUpdateToList(
            collectionListPage.resource_List,
            data,
            failResources,
          ),
        },
      });
    },
  },

  reducers: {
    change(
      state: CollectionListPageModelState,
      action: ChangeAction,
    ): CollectionListPageModelState {
      return {
        ...state,
        ...action.payload,
      };
    },
  },

  subscriptions: {
    setup({ dispatch, history }: SubscriptionAPI) {},
  },
};

export default Model;

